/** Where a project's lookbook is served. */
export const lookbookHref = (urlSegment: string): string =>
    `/project/${urlSegment}/lookbook.pdf`;
